/**
 * Share one in-flight request between identical concurrent callers (read-only queries only).
 * Not a cache: the key is released as soon as the request settles, success or failure.
 */
export function createInFlightShare<T>(): (key: string, run: () => Promise<T>) => Promise<T> {
  const inFlight = new Map<string, Promise<T>>();
  return (key, run) => {
    const existing = inFlight.get(key);
    if (existing) return existing;
    const started = run().finally(() => { inFlight.delete(key); });
    inFlight.set(key, started);
    return started;
  };
}
